/**
 * @file components/BottomSubmit
 * @description 表单底部提交按钮区域
 * @author xuemin02
 */

import React from 'react';
import _ from 'lodash';
import {Button} from 'acud';

import './index.less';

const BottomSubmitContainer = props => {
    const {options = []} = props;

    return (
        <div className="acud-pro-bottom-submit">
            <div className="bottom-box">
                {_.map(options, (option, index) => {
                    const {text, ...buttonProps} = option;
                    return (
                        <Button size="large" {...buttonProps} key={index}>
                            {text}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};

export default BottomSubmitContainer;
